import bindEvent from "@/script/bindevent.js";

const state = {
    log: [],
    
}

const mutations = {};

const actions = {
    // 异步操作
    async run(context) {
        bindEvent.run(context)
    },
};

const getters = {};

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
